/* ==========================================================================
   LALTERNATIVA - Hero video: ogni clip riparte dall'inizio quando tocca a lei
   Caricato da layout/theme.liquid. 22/10/2026 - tema V1.8

   IL DIFETTO DI PARTENZA. La sezione "Hero video LAS" manda avanti la
   sequenza quando il video in scena finisce (evento 'ended'). Pero' i video
   NON in scena partivano lo stesso al caricamento della pagina e giravano
   invisibili: quando arrivava il loro turno erano gia' a meta' o gia'
   finiti, e la sequenza saltava subito oltre.
   Misurato a pagina appena aperta: clip 1 attiva a currentTime 0, clip 2 non
   attiva ma gia' a 7,9. Una clip e' entrata in scena a 12,4 su 14,3 secondi
   di durata ed e' rimasta visibile 1,8 secondi.

   LA CORREZIONE. Due regole: quando una clip ENTRA in scena viene riavvolta
   a 0 e fatta partire; quando non e' in scena resta in pausa. Cosi' non
   girano nemmeno quattro video insieme in sottofondo, che a 4,5 Mbps l'uno
   non e' poco.

   ERRORE DELLA PRIMA VERSIONE (22/10/2026, sera) - DA NON RIFARE.
   Per intercettare i video montati in differita ripassavo la lista a 100,
   300, 700, 1500, 3000 e 6000 millisecondi, e a ogni passaggio riapplicavo
   la regola a TUTTE le slide, comprese quelle gia' sorvegliate. Sulla clip
   in scena quella regola dice "riavvolgi a 0": risultato, la prima clip
   ripartiva da capo quattro o cinque volte nei primi sei secondi, poi tutto
   tornava normale. Segnalato da Diego come "il primo video riparte 4 volte".
   Ora il riavvolgimento scatta SOLO sul passaggio da non-attiva ad attiva:
   ogni slide ricorda il proprio stato precedente e i ripassi periodici si
   limitano alle slide non ancora sorvegliate.
   In piu', al primo giro la clip gia' in scena non viene toccata: si mettono
   in pausa soltanto le altre. Cosi' chi apre la pagina non vede nemmeno un
   salto.

   VERIFICA dopo la correzione, dal primo giro: ogni clip resta in scena per
   la propria durata piena (16,9 / 19,3 / 15,2 / 14,3 secondi).

   SE UN DOMANI SI TOGLIE: la sequenza torna a saltare le clip che non sono
   la prima. Nient'altro dipende da questo file.
   ========================================================================== */

(function () {
  if (window.lasHeroFixReady) return;
  window.lasHeroFixReady = true;

  var SEL_SLIDE = '.las-hero-video__slide';

  function entraInScena(v) {
    try { if (v.currentTime > 0.05) v.currentTime = 0; } catch (e) {}
    var p = v.play();
    if (p && p.catch) p.catch(function () {});
  }

  /* Agisce solo se lo stato e' CAMBIATO rispetto all'ultimo giro. */
  function cambio(slide) {
    var v = slide.querySelector('video');
    if (!v) return;
    var attiva = slide.classList.contains('is-active');
    if (attiva === slide.lasHeroAttiva) return;
    slide.lasHeroAttiva = attiva;
    if (attiva) entraInScena(v);
    else if (!v.paused) v.pause();
  }

  /* Primo contatto: si registra lo stato e si mettono in pausa le clip di
     riserva. La clip gia' in scena non si tocca, per non farla ripartire. */
  function sorveglia(slide) {
    if (slide.lasHeroWatched) return;
    var v = slide.querySelector('video');
    if (!v) return;
    slide.lasHeroWatched = true;
    slide.lasHeroAttiva = slide.classList.contains('is-active');
    if (!slide.lasHeroAttiva && !v.paused) v.pause();
    new MutationObserver(function () { cambio(slide); }).observe(slide, {
      attributes: true,
      attributeFilter: ['class']
    });
  }

  function scan() {
    var slides = document.querySelectorAll(SEL_SLIDE);
    for (var i = 0; i < slides.length; i++) sorveglia(slides[i]);
  }

  function avvio() {
    scan();
    /* i video arrivano in differita: si ripassa, ma sorveglia() ignora
       quelle gia' prese in carico, quindi nessuna clip viene riavvolta */
    [100, 300, 700, 1500, 3000, 6000].forEach(function (t) { setTimeout(scan, t); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', avvio);
  } else {
    avvio();
  }
  document.addEventListener('shopify:section:load', scan);
})();
